import { LogLevel } from '@optimizely/js-sdk-logging';
import { createInstance, enums } from '@optimizely/react-sdk';

import { frontendAnalyticsTrack } from 'analytics/utils';

import { DecisionListener } from './types';

const optimizely = createInstance({
  datafile: window.optimizelyDatafile,
  logLevel: LogLevel.WARNING,
});

optimizely.notificationCenter.addNotificationListener<DecisionListener>(
  enums.NOTIFICATION_TYPES.DECISION,
  (attrs) => {
    if (attrs.type === 'flag' && attrs.decisionInfo.decisionEventDispatched) {
      frontendAnalyticsTrack('Feature Experiment Viewed', {
        flagKey: attrs.decisionInfo.flagKey,
        variationKey: attrs.decisionInfo.variationKey,
        featureEnabled: attrs.decisionInfo.enabled,
        ruleKey: attrs.decisionInfo.ruleKey,
        variables: attrs.decisionInfo.variables,
      });
    }
  }
);

export default optimizely;
